import { detectBrand, digitsOnly } from '../cardUtils.js';

/**
 * The test simulator's tokenizer.
 *
 * It runs entirely in the browser and calls nothing. What it produces is a token
 * in exactly the shape a real tokenizer produces: opaque to this page, carrying
 * a decision, a brand and four digits — and *not* a card number.
 *
 * That last part is the reason this exists rather than a server-side "test mode".
 * HC-4 and HC-5 hold here as they do for a real gateway, so a merchant who tests
 * against the simulator is testing the integration they will actually ship. A
 * test path that let the PAN through would teach them the opposite, and the
 * confirm endpoint would reject it anyway.
 */
const OUTCOME_BY_NUMBER = {
  '4000000000000002': 'declined',
  '4000000000009995': 'declined',
  '4000000000000069': 'declined',
  '4000000000000127': 'declined',
  '4000000000000259': 'review',
  '4000000000000101': 'timeout',
};

export const simulatorTokenizer = {
  library: 'simulator',

  /** Nothing to load. Resolved so the caller's flow is identical either way. */
  async load() {
    return true;
  },

  async tokenize({ card }) {
    const digits = digitsOnly(card.number);

    // Unrecognised numbers approve: somebody poking at the checkout with a
    // made-up number wants the happy path, not a scavenger hunt.
    const outcome = OUTCOME_BY_NUMBER[digits] ?? 'approved';
    const brand = detectBrand(digits).brand ?? 'unknown';
    const last4 = digits.slice(-4).padStart(4, '0');

    // The same shape a real provider's token takes, so nothing downstream has to
    // know which provider produced it.
    return { dataDescriptor: 'DISTRXPAY.SIMULATOR', dataValue: `simtok_${outcome}_${brand}_${last4}` };
  },
};

export default simulatorTokenizer;
